/** Stable machine-readable codes carried by the `data-error` part. */
export enum CopilotErrorCodeEnum {
  MULTI_TIMESLOT_SESSION = "multi_timeslot_session",
  INVALID_URL = "invalid_url",
  DOCUMENT_REQUIRED = "document_required",
  SOURCE_UNREADABLE = "source_unreadable",
  NOT_FOUND = "not_found",
  /** A sign-in sheet matched no session — a session, never a training, is what could not be found. */
  SESSION_NOT_FOUND = "session_not_found",
  FORBIDDEN = "forbidden",
  /** Client-side: told apart from FORBIDDEN so an expired session does not read as a missing right. */
  SESSION_EXPIRED = "session_expired",
  /** Client-side: the PDF is readable, it is only too heavy — the message names the limit. */
  DOCUMENT_TOO_LARGE = "document_too_large",
  /** Client-side: the round-trip broke without naming a reason — the transport, not the request. */
  RESPONSE_INTERRUPTED = "response_interrupted",
  TEMPORARY_FAILURE = "temporary_failure",
  OPERATION_FAILED = "operation_failed",
}

/** Recovery the frontend may offer for a Copilote error. */
export enum CopilotErrorRecoveryEnum {
  RETRY = "retry",
  CORRECT_INPUT = "correct_input",
  ATTACH_PDF = "attach_pdf",
  NONE = "none",
}
